module.exports = __webpack_public_path__ + "img/22.18276922.jpg";